const PENDING_STATUSES = new Set(["pending", "processing", "in_progress", "partial"]);

export function isExtractionPending(status: string | null | undefined): boolean {
  return !status || PENDING_STATUSES.has(status);
}

function hasNestedString(obj: unknown, key: string): boolean {
  if (!obj || typeof obj !== "object") return false;
  const val = (obj as Record<string, unknown>)[key];
  return typeof val === "string" && val.trim().length > 0;
}

function hasNamedEntry(value: unknown): boolean {
  return Array.isArray(value) && value.some((entry) => hasNestedString(entry, "name"));
}

export function hasValidLettersData(specific: Record<string, unknown> | null | undefined): boolean {
  if (!specific) return false;
  const hasCourt = hasNestedString(specific.court_information, "court_name");
  const hasExecutor = hasNestedString(specific.executor_information, "executor_name");
  const hasAdmin = hasNestedString(specific.administrator_information, "administrator_name");
  return hasCourt && (hasExecutor || hasAdmin);
}

export function hasValidTrustData(specific: Record<string, unknown> | null | undefined): boolean {
  if (!specific) return false;
  const hasTrustName = hasNestedString(specific.trust_information, "trust_name");
  const hasGrantor =
    hasNestedString(specific.trust_information, "grantor_name_as_printed") ||
    hasNestedString(specific.trust_information, "grantor_name");
  const hasTrustee = hasNamedEntry(specific.trustees);
  return hasTrustName && (hasTrustee || hasGrantor);
}
